import { isMobile } from 'mobile-device-detect';

export const whatsAppUrl = isMobile ? 'https://wa.me/+33783831717' : 'https://web.whatsapp.com/send?phone=+33783831717';